import { SvgIconProps } from '@mui/material';
import { iconRegistry, ModuleIconKey } from './iconRegistry';

interface IModuleIconProps {
  name: ModuleIconKey;
  sx?: SvgIconProps['sx'];
}

export const ModuleIcon: React.FC<IModuleIconProps> = ({ name, sx }) => {
  const Icon = iconRegistry[name];
  return <Icon sx={sx} />;
};
